var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 195,
    viewBox: "0 0 248 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 195,
    fill: "#121212"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.53 78.2356L112.642 60.4578C112.272 59.7193 111.705 59.0982 111.002 58.6642C110.3 58.2301 109.49 58.0001 108.665 58H86.4441C84.7598 58 83.2221 58.9511 82.4666 60.4578L74.8095 75.7778H55.3355C53.6511 75.7778 52.1135 76.7289 51.358 78.2356L42.4698 96.0133C42.1609 96.6308 42 97.3118 42 98.0022C42 98.6927 42.1609 99.3736 42.4698 99.9911L51.358 117.769C52.1135 119.271 53.6511 120.222 55.3355 120.222H74.8095L82.4711 135.542C82.8391 136.281 83.4059 136.902 84.1078 137.337C84.8097 137.771 85.6188 138.001 86.4441 138H108.665C110.349 138 111.887 137.049 112.642 135.542L121.53 117.764C121.839 117.147 122 116.466 122 115.776C122 115.085 121.839 114.404 121.53 113.787L113.633 98L121.526 82.2089C121.835 81.5923 121.996 80.9124 121.997 80.2227C121.997 79.5331 121.838 78.8528 121.53 78.2356ZM89.1905 66.8889H105.918L112.584 80.2222L105.918 93.5556H89.1905L82.5244 80.2222L89.1905 66.8889ZM51.4158 98L58.0819 84.6667H74.8095L81.4756 98L74.8095 111.333H58.0819L51.4158 98ZM105.918 129.111H89.1905L82.5244 115.778L89.1905 102.444H105.918L112.584 115.778L105.918 129.111Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148 86C139.178 86 132 93.1776 132 102C132 110.822 139.178 118 148 118C156.822 118 164 110.822 164 102C164 93.1776 156.822 86 148 86Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175.002 102C175.002 93.7299 181.732 87 190.002 87C198.273 87 205.002 93.7299 205.002 102C205.002 110.27 198.273 117 190.002 117C181.732 117 175.002 110.27 175.002 102Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHex);
export default __webpack_public_path__ + "static/media/hex.2bde4a4f3fdfc000219c1ab20841eb2a.svg";
export { ForwardRef as ReactComponent };